import React from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';

const SubjectList = ({ subjects, getSubjectCount, onSubjectClick }) => {
  // subjects가 없는 경우 로딩 표시
  if (!subjects || subjects.length === 0) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h5" component="h2" sx={{ color: 'primary.main', mb: 3 }}>
          Subject List
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" component="h2" sx={{ color: 'primary.main', mb: 3 }}>
        Subject List
      </Typography>
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
        gap: 2
      }}>
        {subjects.map((subject) => {
          const termCount = getSubjectCount ? getSubjectCount(subject) : 0;
          return (
            <Paper
              key={subject}
              elevation={1}
              onClick={() => onSubjectClick && onSubjectClick(subject)}
              sx={{
                p: 2,
                cursor: 'pointer',
                transition: 'all 0.2s',
                '&:hover': {
                  transform: 'translateY(-2px)',
                  boxShadow: 3
                },
                ...(subject === 'Must Know' && {
                  backgroundColor: '#f5f5f5',
                  border: 'none',
                  fontWeight: 600,
                })
              }}
            >
              <Typography fontWeight={subject === 'Must Know' ? 600 : 400}>
                {subject}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                {termCount}개의 용어
              </Typography>
            </Paper>
          );
        })}
      </Box>
    </Box>
  );
};

export default SubjectList; 